import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { formatCustomizationForDisplay } from '../../utils/customizationUtils';
import './index.css';

const Cart: React.FC = () => {
  const navigate = useNavigate();
  const { cart, removeFromCart, clearCart, addToCart } = useCart();

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const updateQuantity = (id: string, change: number) => {
    const item = cart.find(i => i.id === id);
    if (item) {
      if (item.quantity + change <= 0) {
        removeFromCart(id);
      } else {
        removeFromCart(id);
        addToCart({ ...item, quantity: item.quantity + change });
      }
    }
  };

  return (
    <div className="cart-container">
      <h2 className="cart-title">Your Cart</h2>
      {cart.length === 0 ? (
        <p className="empty-cart-message">Your cart is empty.</p>
      ) : (
        <div className="cart-content">
          <div className="cart-items">
            {cart.map(item => (
              <div key={item.id} className="cart-item">
                <div className="item-details">
                  <div className="item-name">{item.name} <span className="quantity">({item.quantity} x ${item.price})</span>
                  {item.is_customizeable && item.customization_items && <span className="customization-items">({formatCustomizationForDisplay(item.customization_items)})</span>}</div>
                </div>
                <div className="quantity-controls">
                  
                  <button 
                    className="quantity-btn-subtract"
                    onClick={() => updateQuantity(item.id, -1)}
                  >
                    -
                  </button>

                  <button 
                    className="quantity-btn-add"
                    onClick={() => updateQuantity(item.id, 1)}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="cart-summary">
            <h3 className="total">Total: ${total.toFixed(2)}</h3>
            <h4>Free shipping on purchases over $100!</h4>
            <div className="shipping-info-note">
              <p><strong>📦 Packaging:</strong> All items are carefully packaged in bubble mailers or box for safe delivery. <a href="/shipping" className="shipping-link">More info</a></p>
            </div>
            <div className="shipping-info-note">
              <p><strong><svg width="16" height="16" viewBox="0 0 16 16" style={{display: 'inline-block', verticalAlign: 'middle', marginRight: '4px'}}><circle cx="8" cy="8" r="7" fill="#C0C0C0" stroke="#A0A0A0" strokeWidth="0.5"/><circle cx="8" cy="8" r="4.5" fill="#000000"/></svg> Keyrings:</strong> Depending on the size and inventory, keyrings and attachment materials may vary slightly per product from what is shown.</p>
            </div>
            <div className="cart-actions">
              <button 
                className="btn btn-secondary"
                onClick={clearCart}
              >
                Clear Cart
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/checkout')}
              >
                Checkout
              </button>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/shop')}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
